import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarusuari from "./Seleccionarusuari";
import Detallsusuari from "./Detallsusuari";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";
import "../dashboard_v2.css";

function idUsuari(u) {
  return u ? Number(u.idUsuaris) : null;
}

function Usuaris() {
  const { rolUsuari } = useUserContext();

  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedUser, setSelectedUser] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [rolFilter, setRolFilter] = useState("");
  const [usuaris, setUsuaris] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleUserSelect = (user) => {
    if (!user) {
      setSelectedUser(null);
      return;
    }
    setSelectedUser((prev) => (idUsuari(prev) === idUsuari(user) ? null : user));
  };

  const obrirFitxa = (user, mode) => {
    setSelectedUser(user);
    setActiveTab(mode);
  };

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaMestres pestanya="usuaris" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                👤
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Usuaris</h1>
                <p className="dv2-pageHeader-subtitle">Accés a l'ERP, rols i empreses.</p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Usuaris" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR", "USUARIS") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedUser(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou usuari
                </button>
              )}
            </div>
          </div>

          <Seleccionarusuari
            onUserSelect={handleUserSelect}
            onConsultar={(u) => obrirFitxa(u, "consultar")}
            onModificar={(u) => obrirFitxa(u, "modificar")}
            onEsborrar={(u) => obrirFitxa(u, "esborrar")}
            selectedUser={selectedUser}
            setUsuaris={setUsuaris}
            reloadToken={reloadToken}
            filters={{
              filterText,
              setFilterText,
              rolFilter,
              setRolFilter,
            }}
          />
        </>
      ) : (
        <Detallsusuari
          mode={activeTab}
          usuari={activeTab === "nou" ? null : selectedUser}
          usuaris={usuaris}
          onNavigate={setSelectedUser}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={setActiveTab}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedUser(updated);
            setUsuaris((prev) =>
              (prev || []).map((u) => (idUsuari(u) === idUsuari(updated) ? { ...u, ...updated } : u))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Usuaris;
